module.exports = __webpack_public_path__ + "img/royal.601eb607.jpg";